export const processStack = (error: Error): string | undefined =>
  error.stack?.split('\n').slice(0, 10).join('\n');
